/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import Swiper from 'swiper';

export var ExemptionsByCategory = BaseControl.extend({
    init: function() {
        this._super();
        this.slidesPerColumn = 7;
        this.swipers = [];
        this.swiperContainer = null;
    },
    collapseVisible: function() {
        let expandedItem = this.element.find('.s-exemption-item.is-expanded');

        if (expandedItem && expandedItem.length) {
            expandedItem.toggleClass('is-expanded');
            expandedItem.find('.s-exemption-item__drawer').slideToggle();
        }
    },

    '.s-exemption-item__content click': function(element) {
        this.exemptionItem = $(element.context).closest('.s-exemption-item');

        if (!this.exemptionItem.hasClass('is-expanded')) {
            this.collapseVisible();
        }

        this.exemptionItem.find('image-cloudinary').each((index, image) => {
            $(image)
                .viewModel()
                .show();
        });

        const $exepmtionBtn = this.exemptionItem.find('.js-exemption-btn');
        const isCollabsed = $exepmtionBtn.attr('aria-expanded') == 'false';
        const $expandedItems = this.element.find(
            '.s-exemption-item .js-exemption-btn',
        );
        $expandedItems.attr('aria-expanded', false);
        if (isCollabsed) {
            $exepmtionBtn.attr('aria-expanded', true);
        }

        this.exemptionItem.toggleClass('is-expanded');
        this.exemptionItem.find('.s-exemption-item__drawer').slideToggle();
        this.swiperContainer = this.exemptionItem.find('.swiper-container');
        this.swiperSlidesLength = this.swiperContainer.find(
            '.swiper-slide',
        ).length;
        this.pagination =
            this.swiperSlidesLength < this.slidesPerColumn
                ? null
                : this.swiperContainer.find('.swiper-pagination');

        if (
            this.swiperSlidesLength > this.slidesPerColumn &&
            this.swiperContainer.find('.swiper-slide').length %
                this.slidesPerColumn >
                1
        ) {
            let i = 0;
            let emptyRowsNumber =
                this.slidesPerColumn -
                (this.swiperContainer.find('.swiper-slide').length %
                    this.slidesPerColumn);
            while (i < emptyRowsNumber) {
                this.swiperContainer
                    .find('.swiper-wrapper')
                    .append(
                        '<div class="swiper-slide s-slide s-slide-empty"></div>',
                    );
                i++;
            }
        }

        let exemptionNumber = parseInt(
            this.exemptionItem
                .find('.s-exemption-number')
                .text()
                .trim(),
        );

        if (!this.swipers[exemptionNumber]) {
            this.swipers[exemptionNumber] = new Swiper(this.swiperContainer, {
                loop: false,
                simulateTouch: true,
                speed: 1000,
                slidesPerColumn: this.slidesPerColumn,
                pagination: {
                    el: this.pagination,
                    clickable: true,
                },
            });
        }
    },
});
